// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 40%;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/alias-list/alias-list.component.less"],"names":[],"mappings":"AACA;EACI,UAAA;AAAJ","sourcesContent":["@import (reference) url('../../../../assets/tables.less');\ntable{\n    width: 40%;     \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
